<template lang="pug">
div
  div(
    v-if="dot.type != 'rooms'",
    ref="dot",
    :class="`floor-plan-dot`",
    :style="{ left: `${dot.x}%`, top: `${dot.y}%`, zIndex: prompt ? 10 : 9 }",
    @mouseover="showPrompt",
    @mouseleave="hidePrompt",
    @mousedown="dragStart",
    @mouseup="dragEnd"
  )
    inline-svg.floor-plan-dot-icon(v-if="dot.icon_url", :src="dot.icon_url", alt="icon") 
    q-icon.floor-plan-dot-icon-remove(name="cancel", v-if="editable && !this.dot.create", @click.stop="removeDot()")

    PointPrompt.floor-plan-dot-prompt(
      ref="prompt",
      :promptData="promptData",
      :style="getPromptStyles",
      :class="pointPromptClasses",
      @showPrompt="showPrompt()",
      @hidePrompt="hidePrompt()"
    )
    PointCreate(
      v-if="dot.create && editable",
      :parentData="{ dot: dot, floor_plan_id: floor_plan_id, types: types, floor_id: floor_id, building_id: building_id }",
      @setDot="setDot",
      @hide="hideCreateDot"
    )
    PointDetail(v-if="active", :detailData="{ dot: dot, active: active }", @hide="hideDetail")
  .floor-plan-area-wrapper(
    v-if="dot.type == 'rooms'",
    :style="{ left: `${dot.x}%`, top: `${dot.y}%`, width: `${dot.width}%`, height: `${dot.height}%` }"
  )
    div(
      :class="`floor-plan-dot area ${dot.figure_type}`",
      ref="dot",
      :style="getDotAreaStyles",
      @mousedown="dragStart",
      @mouseup="dragEnd",
      @mousemove="showPrompt",
      @mouseleave="hidePrompt",
      @click="setCurrent"
    )
    .tensile-zone(@mousedown="resizeStart", @mouseup="resizeEnd", v-if="current")
      q-icon(name="open_in_new_down")
    PointPrompt.floor-plan-dot-prompt.rooms(
      ref="promptRoom",
      :promptData="promptData",
      :style="getPromptStyles",
      @showPrompt="showPrompt()",
      @hidePrompt="hidePrompt()",
      :class="pointPromptClasses"
    )
</template>

<script>
import PointPrompt from "./point/prompt.vue";
import PointDetail from "./point/detail.vue";
import PointCreate from "./point/create.vue";

export default {
  components: {
    PointPrompt,
    PointDetail,
    PointCreate,
  },

  props: {
    dotData: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data: function () {
    return {
      dot: this.dotData.dot,
      floor_plan_id: this.dotData.floor_plan_id,
      floor_id: this.dotData.floor_id,
      building_id: this.dotData.building_id,
      types: this.dotData.types,
      dotInfo: {},
      active: false,
      editable: this.dotData.editable,
      prompt: false,
      promptX: 0,
      promptY: 0,
      pointPromptClasses: "",
      dragging: false,
      img: {},
      // переменные для хранения предыдущих значений размеров точки при ресайзе
      prevWidth: Number,
      prevHeight: Number,
      // переменные для хранения начальных значений точки в координатах при ресайзе
      resizeX: Number,
      resizeY: Number,
      resizing: false,
      // переменная для хранения DOM элемента точки
      dotEl: Object,
      // переменные для хранения предыдущих значений координат точки
      prevX: Number,
      prevY: Number,
      // переменные для хранения отступов от обертки плана этажа у точки
      areaLayerX: Number,
      areaLayerY: Number,
      // прееменные для хранения размеров точки в пикселях
      dotPixelWidth: Number,
      dotPixelHeight: Number,
      wrapperHeight: 500,
      wrapperWidth: 900,
      // переменная для хранения таймаута исчезновения промпта в showPrompt и hidePrompt
      propsHiddingTimeout: "",
      // значение высоты по умолчанию, новое значение назначается в showPrompt
      promptHeight: 200,
    };
  },

  computed: {
    getPromptStyles() {
      return { left: this.promptX + "px", top: this.promptY + "px", visibility: this.prompt ? "visible" : "hidden" };
    },

    getDotAreaStyles() {
      return {
        zIndex: this.prompt ? 3 : 2,
        border: `${this.dot.border_width}px solid ${this.dot.color}`,
        transform: `rotate(${this.dot.rotate}deg)`,
      };
    },

    promptData() {
      return { dot: this.dot, floor_plan_id: this.floor_plan_id, maxHeight: this.promptHeight };
    },
  },

  methods: {
    showPrompt(e) {
      clearTimeout(this.propsHiddingTimeout);
      if (!this.dragging && this.dot && !this.dot.create) {
        const promptEl = this.dot?.type === "rooms" ? this.$refs.promptRoom.$el : this.$refs.prompt.$el;
        const dot = this.$refs.dot;
        const dotRect = dot.getBoundingClientRect();
        this.promptX = this.dot?.type === "rooms" ? dotRect.left + dotRect.width / 2 : dotRect.left;
        this.promptY = dotRect.top;
        const dotOffsetTop = dotRect.top;
        const dotOffsetBottom = window.innerHeight - dotRect.bottom;

        const offsetFromWindowBorders = 80;
        const additionalMarginForArrow = 18;

        if (dotOffsetTop > dotOffsetBottom) {
          this.promptHeight = dotOffsetTop - offsetFromWindowBorders;
          if (this.dot.type === "rooms") {
            this.promptY = dotRect.top + additionalMarginForArrow;
          } else {
            this.promptY = dotRect.top;
          }
        } else {
          this.promptHeight = dotOffsetBottom - offsetFromWindowBorders;
          this.pointPromptClasses = "reverse";
          if (this.dot.type === "rooms") {
            this.promptY = dotRect.bottom - additionalMarginForArrow;
          }
        }
        this.prompt = true;
      }
    },

    setDot(data) {
      this.$emit("setDot", data);
      this.$emit("setCurrent", this.dot);
    },

    hidePrompt() {
      this.propsHiddingTimeout = setTimeout(() => {
        this.prompt = false;
        this.pointPromptClasses = "";
      }, 100);
    },

    setCurrent() {
      this.$emit("setCurrent", this.dot);
    },

    // showDetail() {
    //   if (!this.dragging && !this.dot.create && this.dot.type !== "sensors") {
    //     this.active = true;
    //   }
    // },

    setType(type) {
      this.dot.type = type;
    },

    hideDetail() {
      this.active = false;
    },

    round(number) {
      return Math.round(parseFloat(number) * 1000) / 10;
    },

    hideCreateDot() {
      this.$emit("hideCreate");
    },

    removeDot() {
      this.$emit("remove");
    },

    updateDot() {
      const plan_points = {
        x: this.dot.x,
        y: this.dot.y,
      };
      if (this.dot.type === "rooms") {
        plan_points["width"] = this.dot.width;
        plan_points["height"] = this.dot.height;
      }
      this.$backend.update(`api/v3/plan_points`, this.dot.id, { plan_point: plan_points }).then(res => {
        this.dragging = false;
      });
      this.$emit("unsetResize");
    },

    resizeStart(e) {
      if (this.editable) {
        this.prevWidth = this.dot.width;
        this.prevHeight = this.dot.height;
        this.resizing = true;
        this.resizeX = e.x;
        this.resizeY = e.y;
        const img = e.target.parentElement.parentElement.parentElement.offsetParent;
        this.img["width"] = img.getBoundingClientRect().width;
        this.img["height"] = img.getBoundingClientRect().height;
        this.img["top"] = img.getBoundingClientRect().top;
        this.img["left"] = img.getBoundingClientRect().left;
        document.addEventListener("mousemove", this.resize);
      }
    },

    resize(e) {
      if (this.resizing) {
        this.dot.width -= ((this.resizeX - e.x) / this.img["width"]) * 100;
        this.dot.height -= ((this.resizeY - e.y) / this.img["height"]) * 100;
        this.resizeX = e.x;
        this.resizeY = e.y;
        if (
          (window.innerWidth - this.wrapperWidth) / 2 - e.x > 0 ||
          (window.innerWidth - this.wrapperWidth) / 2 + this.wrapperWidth < e.x ||
          (window.innerHeight - this.wrapperHeight) / 2 - e.y > 0 ||
          (window.innerHeight - this.img.height) / 2 - e.y > 0 ||
          (window.innerHeight - this.wrapperHeight) / 2 + this.wrapperHeight < e.y ||
          (window.innerHeight - this.img.height) / 2 + this.img.height < e.y
        ) {
          document.removeEventListener("mousemove", this.resize);
          this.dot.width = this.prevWidth;
          this.dot.height = this.prevHeight;
          return;
        }
      }
    },

    resizeEnd(e) {
      document.removeEventListener("mousemove", this.resize);
      this.resizing = false;
      this.updateDot();
    },

    dragStart(e) {
      if (this.editable && !this.dot.create && !e.target.classList.contains("floor-plan-dot-icon-remove")) {
        e.preventDefault();
        this.prompt = false;
        this.dragging = true;
        const img = e.target.closest(".floor-plan-editor-wrapper");
        const dotEl = e.target.closest(".floor-plan-dot");
        this.img["width"] = img.getBoundingClientRect().width;
        this.img["height"] = img.getBoundingClientRect().height;
        this.img["top"] = img.getBoundingClientRect().top;
        this.img["left"] = img.getBoundingClientRect().left;
        this.prevX = this.dot.x;
        this.prevY = this.dot.y;
        this.areaLayerX = e.layerX;
        this.areaLayerY = e.layerY;
        this.dotPixelWidth = dotEl.getBoundingClientRect().width;
        this.dotPixelHeight = dotEl.getBoundingClientRect().height;
        document.addEventListener("mousemove", this.drag);
      }
    },

    drag(e) {
      if (this.dragging) {
        const offsetRight = this.dotPixelWidth - e.offsetX;
        const offsetBottom = this.dotPixelHeight - e.offsetY;
        const offsetLeft = e.offsetX;
        const offsetTop = e.offsetY;
        this.prompt = false;
        const currentPositionY = e.y - this.img.top - this.areaLayerY;
        const currentPositionX = e.x - this.img.left - this.areaLayerX;
        const y = this.round(currentPositionY / this.img.height);
        const x = this.round(currentPositionX / this.img.width);
        this.dot.y = y;
        this.dot.x = x;
        const marginFromWindowBordersLeftRight = (window.innerWidth - this.wrapperWidth) / 2;
        const marginFromWindowBordersTopDown = (window.innerHeight - this.wrapperHeight) / 2;
        const marginFromWindowBordersTopDownWithSmallImgae = (window.innerHeight - this.img.height) / 2;
        const additionalOffsetForDraggingToBottom = 15;
        const floorPlanBorderBottom = e.y - additionalOffsetForDraggingToBottom;
        if (
          marginFromWindowBordersLeftRight + this.wrapperWidth - offsetRight - e.x <= 0 ||
          marginFromWindowBordersLeftRight + offsetLeft >= e.x ||
          marginFromWindowBordersTopDown + offsetTop - e.y > 0 ||
          marginFromWindowBordersTopDownWithSmallImgae + offsetTop - e.y > 0 ||
          marginFromWindowBordersTopDown + this.wrapperHeight - offsetBottom < e.y - floorPlanBorderBottom ||
          marginFromWindowBordersTopDownWithSmallImgae + this.img.height - offsetBottom < e.y - floorPlanBorderBottom
        ) {
          document.removeEventListener("mousemove", this.drag);
          this.dot.x = this.prevX;
          this.dot.y = this.prevY;
          return;
        }
      }
    },

    dragEnd(e) {
      if (this.dragging) {
        e.preventDefault();
        if (this.prevX !== this.dot.x || this.prevY !== this.dot.y) {
          this.updateDot();
        } else {
          this.dragging = false;
        }
        document.removeEventListener("mousemove", this.drag);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/floor-plan/main";
</style>
